import React from "react";
import FileManager, { Permissions } from "devextreme-react/file-manager";
import { useWindowDimensions } from "@app/contexts";
import "./download.scss";

const fileItems = [
  {
    name: "Demo",
    isDirectory: true,
    items: [
      {
        name: "Jurnal Gold Setup( dummy ).exe",
        isDirectory: false,
        size: 1024,
      },
    ],
  },
];
export const Download = () => {
  const { drawerHeight } = useWindowDimensions();
  return (
    <FileManager
      className="file-manager"
      height={`${drawerHeight}px`}
      fileSystemProvider={fileItems}
    >
      <Permissions
        create={false}
        copy={false}
        move={false}
        delete={false}
        rename={false}
        upload={false}
        download={true}
      ></Permissions>
    </FileManager>
  );
};
